import type React from 'react';

import { ChanelLayout } from './ChanelLayout';
import { DiorLayout } from './DiorLayout';

import { BRANDS } from '@/utilities/constants';

type GetLayoutProps = {
  children?: React.ReactNode;
  query?: string;
  isRebrand?: boolean;
};

export const Layout = ({ children, query, isRebrand }: GetLayoutProps) => {
  if (query?.includes(BRANDS.chanel)) {
    return <ChanelLayout isRebrand={isRebrand}>{children}</ChanelLayout>;
  } else if (query?.includes(BRANDS.dior)) {
    return <DiorLayout isRebrand={isRebrand}>{children}</DiorLayout>;
  }
  return <>{children}</>;
};
